import { Component, OnInit } from '@angular/core';

interface Food {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'app-grid-filter',
    templateUrl: './grid-filter.component.html',
    styleUrls: ['./grid-filter.component.scss'],
    standalone: false
})
export class GridFilterComponent implements OnInit {
  selectedValue: string;
  selectedCar: string;
  foods: Food[] = [
    { value: '000822', viewValue: '000822' },
    { value: '000823', viewValue: '000823' },
    { value: '000824', viewValue: '000824' },
  ];

  constructor() {}

  ngOnInit(): void {}
}
